/* CATEGORY MENU SCRIPT */
window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1000 / 60);
  };
window["prismPlus2428"] = function () {
  if (
    typeof jQuery == "function" &&
    jQuery("#MainContent").length &&
    !document.getElementsByClassName("monitor-nov").length
  ) {
    document.body.classList.add("prismPlus2428");
    document.body.classList.add("novfix");
    jQuery("body").removeClass("template-page").addClass("template-collection");

    jQuery(".categoryStickyBar ul li").first().addClass("activeLiNavScrolled");
    jQuery(document).on("click", ".categoryStickyBar ul li", function () {
      var thisLi = jQuery(this),
        thisID = jQuery(thisLi.attr("data-id")),
        header = jQuery("#shopify-section-header"),
        categorySticky = jQuery(".categoryStickyBar");
      jQuery(".categoryStickyBar ul li").removeClass("activeLiNavScrolled");
      jQuery(this).addClass("activeLiNavScrolled");
      //jQuery('body, html').animate({'scrollTop': thisID.offset().top - (header.innerHeight() + categorySticky.innerHeight())});
      //jQuery('body, html').animate({'scrollTop': thisID.offset().top - (header.innerHeight() + categorySticky.innerHeight() + 40)});
      jQuery(".categoryStickyBar").animate({
        scrollLeft:
          jQuery(".categoryStickyBar").scrollLeft() + thisLi.position().left,
      });

      if (jQuery(window).width() < 767) {
        if (jQuery(".categoryStickyBar").hasClass("categoryStickyActive")) {
          jQuery("body, html").animate({
            scrollTop:
              thisID.offset().top -
              (header.innerHeight() + categorySticky.innerHeight()),
          });
        } else {
          jQuery("body, html").animate({
            scrollTop:
              thisID.offset().top -
              (header.innerHeight() + categorySticky.innerHeight() + 50),
          });
        }
      } else {
        jQuery("body, html").animate({
          scrollTop:
            thisID.offset().top -
            (header.innerHeight() + categorySticky.innerHeight()),
        });
      }
    });

    var t_ScrollInit;
    jQuery(window).scroll(function () {
      var scrollTop = jQuery(this).scrollTop(),
        categoryStickyFix = jQuery(".categoryStickyHeightFix"),
        categorySticky = jQuery(".categoryStickyBar"),
        header = jQuery("#shopify-section-header");

      // console.log("categoryStickyFix offset: ", categoryStickyFix.offset().top);

      if (scrollTop + header.innerHeight() > categoryStickyFix.offset().top) {
        categorySticky
          .addClass("categoryStickyActive")
          .css({ position: "fixed", top: header.innerHeight(), left: "0" });
      } else {
        categorySticky
          .removeClass("categoryStickyActive")
          .css({ position: "relative", top: "0", left: "0" });
      }
      /* ------------- */
      var scrollTop = jQuery(window).scrollTop(),
        winHeight = jQuery(window).height(),
        topSpacing =
          jQuery("#shopify-section-header").innerHeight() +
          jQuery(".categoryStickyBar").innerHeight(),
        lastID = "";
      jQuery("#Collection .itemsCategoryWrapper").each(function () {
        var thisWrap = jQuery(this),
          thisID = jQuery(this).attr("id");
        if (
          scrollTop + winHeight / 2 > thisWrap.offset().top &&
          scrollTop < thisWrap.offset().top + thisWrap.innerHeight()
        ) {
          jQuery(".categoryStickyBar ul li").removeClass("activeLiNav");
          jQuery(
            '.categoryStickyBar ul li[data-id="#' + thisID + '"]'
          ).addClass("activeLiNav");
          lastID = thisID;
        }
      });
      clearTimeout(t_ScrollInit);
      t_ScrollInit = setTimeout(function () {
        var lastActiveLi = jQuery(
          '.categoryStickyBar ul li[data-id="#' + lastID + '"]'
        );
        if (lastActiveLi.length) {
          if (!lastActiveLi.hasClass("activeLiNavScrolled")) {
            jQuery(".categoryStickyBar ul li").removeClass(
              "activeLiNavScrolled"
            );
            lastActiveLi.addClass("activeLiNavScrolled");
            jQuery(".categoryStickyBar").animate({
              scrollLeft:
                jQuery(".categoryStickyBar").scrollLeft() +
                lastActiveLi.position().left,
            });
          }
        }
      }, 100);
    });
    jQuery(window).trigger("scroll");
    // console.log("Running collection-nov-monitor-fix.js");
  } else if (!document.getElementsByClassName("prismPlus2428").length) {
    window.requestAnimationFrame(prismPlus2428);
  }
};

document.addEventListener(
  "readystatechange",
  (event) => {
    const readyState = event.target.readyState;
    if (readyState === "complete") {
      const categoryStickyHeightFix = document.querySelector(
        ".categoryStickyHeightFix"
      );
      if (categoryStickyHeightFix) {
        window.prismPlus2428();
      } else {
        // console.error("no categoryStickyHeightFix");
      }
    }
  },
  { once: true }
);

// if(window.location.href.indexOf('/collections/gaming-monitors') != -1){
//   window.prismPlus2428();
// }
